module.exports = __webpack_public_path__ + "img/sj.cc28ac8f.png";